import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export default class AssetsIntelligenceServices {
  getAssets(args?: string) {
    // GetBackendUrlForGlobalFunctions() + `asset-hierarchy/asset?where=`+args;
    let theData =
      GetBackendUrlForGlobalFunctions() + `asset-hierarchy/asset?where=` + args;
    return axios.get(theData);
  }
  AddAssets(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.post(
      GetBackendUrlForGlobalFunctions() + `asset-hierarchy/assets/create`,
      obj,
      { headers }
    );
  }

  EditAssets(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.post(
      GetBackendUrlForGlobalFunctions() + `asset-hierarchy/assets/edit`,
      obj,
      { headers }
    );
  }

  DeleteAssets(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.post(
      GetBackendUrlForGlobalFunctions() + `asset-hierarchy/assets/delete`,
      obj,
      { headers }
    );
  }
}
